import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { InputParametersHierarchyContext } from '../ai/inputParametersHierarchy'
import { RootState } from '../store'
import { InputParameterHierarchyType } from '../../components/InputParameterHierarchy/model'

export interface TemplateSelectionParams {
  header: string
  subHeader: string
  type: InputParameterHierarchyType
  typeId: string
  context: InputParametersHierarchyContext
  templateId?: string
  nodeId?: string
}

interface TemplateSelectionState {
  templateSelectionParams: TemplateSelectionParams | null
}

const initialState: TemplateSelectionState = {
  templateSelectionParams: null,
}

export const templateSelectionSlice = createSlice({
  name: 'templateSelection',
  initialState,
  reducers: {
    setTemplateSelectionParams: (state, action: PayloadAction<TemplateSelectionParams>) => {
      state.templateSelectionParams = action.payload
    },
    clearTemplateSelectionParams: (state) => {
      state.templateSelectionParams = null
    },
  },
})

export const { setTemplateSelectionParams, clearTemplateSelectionParams } = templateSelectionSlice.actions

export const selectTemplateSelectionParams = (state: RootState) => state.templateSelection.templateSelectionParams

export default templateSelectionSlice.reducer
